import Vue from 'vue'

const state = {
  suppliers: {}
}

const mutations = {
  SET_SUPPLIERS (state, suppliers) {
    state.suppliers = suppliers
  }
}

const actions = {
  fetchAll: ({commit}) => {
    return Vue.prototype.$axios.get('suppliers')
      .then(response => {
        commit('SET_SUPPLIERS', response.data)
      })
  }
}

const getters = {
  fetchById: state => id => {
    return state.suppliers[id]
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
